import React from "react";
import "../../Flight/FlightDetail/ReviewPassenger.css"; 
import { ClipLoader } from "react-spinners";

const CabReviewPage = ({
   onConfirm,      // use same name as parent
  onClose,
  email,
  phone,
  firstName,
  lastName,
  title,
  confirmLoading,
}) => {
  return (
    <div className="review_passenger_detail">
      <div className="overlayss">
        <p className="overlayBggg" />
        <div className="commonOverlay" style={{ width: 530 }}>
          <span
            className="bgProperties overlayCrossIcon icon20"
            style={{
              backgroundImage:
                'url("https://jsak.mmtcdn.com/flights/assets/media/cross-icon.png")',
            }}
            onClick={onClose}
          />
          <h3 className="fontSize24 boldFont appendBottom12">Review Details</h3>
          <p className="darkText review_page_para">
            Please ensure that the spelling of your name and other details match
            with your travel document/govt. ID, as these cannot be changed
            later. Errors might lead to cancellation penalties.
          </p>

          <div className="reviewDtlsOverlayContent customScroll">
            <div  className="tvlrDtlsCard">
                   
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Name</span>
                      <span className="blackText boldFont flexOne">
                        {title} {firstName} {lastName}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Gender</span>
                      <span className="blackText boldFont flexOne">
                        {title === "Mr" ? "Male" : "Female"}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Email</span>
                      <span className="blackText boldFont flexOne">
                        {email || "N/A"}
                      </span>
                    </p>
                    <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Phone Number</span>
                      <span className="blackText boldFont flexOne">
                        {phone || "—"}
                      </span>
                    </p>
                    {/* <p className="makeFlex appendBottom7">
                      <span className="tvlrLftInfo">Fare</span>
                      <span className="blackText boldFont flexOne">
                        ₹{Math.round (t.fare)}
                      </span>
                    </p> */}
                  </div>
          </div>

          <div className="detailsPopupFooter">
            <span
              className="review_pass_editt appendRight20 linkText"
              onClick={onClose}
            >
              EDIT
            </span>
            <button
                onClick={onConfirm}
                  disabled={confirmLoading}
              type="button"
              className="button buttonPrimary buttonBig fontSize14 review_pass_condifmr"
            >
              {confirmLoading ? (
                <ClipLoader color="#fff" size={20} />
              ) : (
                "CONFIRM"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CabReviewPage;
